<template>
  <div>
    <v-progress-circular v-show="$apollo.loading" indeterminate :size="50" color="primary"></v-progress-circular>

    <v-card v-show="!$apollo.loading">
      <v-card-title primary-title>
        <h3 class="headline mb-0">Itineraries By Staff</h3>
      </v-card-title>

      <v-card-text class="px-2">
        <pie-chart :chart-data="dataCollection" :height="200"></pie-chart>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="orange">Chart Options</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import PieChart from "./PieChart";
import { ALL_ITINERARIES_STAFF_QUERY } from "../../../../constants/graphql";
export default {
  name: "ItinerariesByStaff",

  components: { PieChart },

  data() {
    return {
      dataCollection: null,
      itineraries: null
    };
  },

  methods: {
    fillData() {
      //this.dataCollection =
      let itisByStaff = {};
      for (let itinerary of this.itineraries.edges) {
        let staffName = itinerary.node.createdBy.name;
        if (!itisByStaff[staffName]) {
          itisByStaff[staffName] = 0;
        }
        itisByStaff[staffName]++;
      }
      //"#" + Math.random().toString(16).slice(2, 8)
      this.dataCollection = {
        labels: Object.keys(itisByStaff),
        datasets: [
          {
            backgroundColor: [
              "#2196F3",
              "#26C6DA",
              "#69F0AE",
              "#FF4081",
              "#90CAF9",
              "#D4E157",
              "#43A047",
              "#18FFFF",
              "#F9A825",
              "#A1887F",
              "#90A4AE",
              "#FF6E40",
              "#E040FB"
            ],
            data: Object.values(itisByStaff)
          }
        ]
      };
    }
  },

  apollo: {
    itineraries: {
      query: ALL_ITINERARIES_STAFF_QUERY,
      variables() {
        return {
          after: this.after,
          filter: this.searchParams
        };
      },
      result({ data, loader, networkStatus }) {
        this.fillData();
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/dashboard/charts/ItinerariesByStaff.vue